import { FunctionComponent } from 'react';
import GenericIcons from '../../../components/generics/GenericIcons';
import { useNavigate } from 'react-router-dom';
import '../../../css/PublicWhatWeDoPage.css';

const Component06: FunctionComponent = () => {
  const navigate = useNavigate();
  const goToLoginPage = () => navigate('/public/login');

  return (
    <div className='public-what-we-do-page-component-six-container vdr-wwd-doc'>
      <div className='vdr-section-head vdr-wwd-section-head'>
        <h2 className='public-what-we-do-page-title'>Puntos robustos de red</h2>
        <small>Mapa de calor</small>
      </div>
      <p className='public-what-we-do-page-text'>
        La herramienta de Puntos robustos de red permite evaluar para cada uno de los nodos de media
        tensión seleccionados por el usuario la máxima capacidad de generación distribuida que
        mantiene las variables operacionales dentro de las restricciones de seguridad y calidad
        definidas en los apartados correspondientes de la norma técnica.
      </p>
      <p className='public-what-we-do-page-text'>
        Utilizamos un algoritmo que emplea la herramienta de evaluación de conexión de proyectos
        para evaluar proyectos de generación distribuida (GD) con capacidades instaladas variables.
      </p>
      <figure style={{ margin: 0 }} className='public-what-we-do-page-component-img-container'>
        <GenericIcons
          icon='capacityIdentificationAlgorithm'
          imageStyle={{
            width: '65%',
            height: 'auto'
          }}
        />
        <figcaption className='public-what-we-do-page-component-img-caption'>
          Figura 9: Algoritmo de identificación de capacidad de alojamiento nodal. Puntos robustos
          de red.
        </figcaption>
      </figure>
      <p className='public-what-we-do-page-text'>
        El algoritmo implementa una búsqueda por bisección de manera iterativa sobre un intervalo
        inicial de búsqueda que va de 0.3 MW a 9 MW. En cada iteración, el algoritmo procede de la
        siguiente manera. Primero, se realiza un estudio de conexión de DG para evaluar el impacto
        del proyecto, considerando que su capacidad es igual al punto medio del intervalo de
        búsqueda (es decir, 4.65 MW en la primera iteración). Luego, si el impacto se determina como
        bajo, el algoritmo ajusta el límite inferior del intervalo de búsqueda igual al punto medio
        actual. Por el contrario, si el impacto es alto, el algoritmo ajusta el límite superior del
        intervalo al punto medio. De este modo, el intervalo de búsqueda se reduce en cada iteración
        y el algoritmo continúa hasta que la diferencia entre los límites superior e inferior sea
        inferior al 1%.
      </p>
      <p className='public-what-we-do-page-text'>
        Como resultado del estudio se despliega en forma de mapa de calor la información de la
        capacidad de alojamiento de cada uno de los nodos evaluados. Facilitando la toma de
        decisiones de desarrolladores de proyectos o clientes que buscan instalar su sistema
        fotovoltaico. Además, también se dispone de la información relacionada a cuál fue la
        restricción de seguridad o calidad que limitó la capacidad de alojamiento en dicho nodo.
      </p>
      <p className='public-what-we-do-page-text'>
        A continuación, un ejemplo de mapa de calor generado en base a los resultados de un estudio
        de puntos robustos en el alimentador Rahue, de SAESA, en Osorno.
      </p>
      <figure style={{ margin: 0 }} className='public-what-we-do-page-component-img-container'>
        <GenericIcons
          icon='HeatmapResulting'
          imageStyle={{
            width: '80%',
            height: 'auto'
          }}
        />
        <figcaption className='public-what-we-do-page-component-img-caption'>
          Figura 10: Mapa de calor resultante de la herramienta de puntos robustos de red.
        </figcaption>
      </figure>
      <p className='public-what-we-do-page-text'>
        De la imagen se desprende que en las cercanías de la cabecera del alimentador es factible en
        términos técnicos conectar proyectos tipo PMGD de hasta 9 MW, mientras que en las zonas más
        alejadas de ella la capacidad conectable es cercana a 4 MW sin la necesidad de incurrir en
        obras adicionales.
      </p>
      <div className='public-what-we-do-page-btn-container'>
        <button className='primary-button-style public-what-we-do-page-btn' onClick={goToLoginPage}>
          Explorar herramienta
          <span aria-hidden='true'>→</span>
        </button>
      </div>
    </div>
  );
};

export default Component06;
